import { useEffect } from "react";

function useGoogleTagManagerScriptInit(gtmId: string) {
    useEffect(() => {
        if (!gtmId) return;

        const script = document.createElement("script");
        const scriptContent = `(function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');`
        script.async = true;
        script.type = "text/javascript";
        script.text = scriptContent;
        document.head.appendChild(script);
    }, [gtmId]);
}

export default useGoogleTagManagerScriptInit;
